import { Box } from "@mui/material"
import React from "react"

export const GenericCircleIcon = ({ children, backgroundColor = 'background.lightBlue', size = '128px', ...others }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      {...others}
      sx={{
        backgroundColor: backgroundColor,
        width: size,
        height: size,
        borderRadius: '100px'
      }}
    >
      {children}
    </Box>
  )
}